module.exports = __webpack_public_path__ + "static/img/minicons4.27838d39.png";